export const isNumeric = (num) => {
  return (
    (typeof num === 'number' ||
      (typeof num === 'string' && num.trim() !== '')) &&
    // eslint-disable-next-line
    !isNaN(num)
  );
};
